

<template>
	<section>
		<compPackagesize v-if="query" :data="formData" :isRate="false"></compPackagesize>
		<template v-else>
			<vFormItem label-width="130" label="包裹尺寸(长宽高)" class="margin-top-10 margin-bottom-5">
				<vInputNumber
					class="inline-block margin-right-15 width-100"
					precision="3"
					clearable
					v-model="formData.packedLength "
					min="0.001"
				/>
				<vInputNumber
					class="inline-block margin-right-15 width-100"
					precision="3"
					clearable
					v-model="formData.packedWidth "
					min="0.001"
				/>
				<vInputNumber
					class="inline-block margin-right-15 width-100"
					precision="3"
					clearable
					v-model="formData.packedHeight "
					min="0.001"
				/>
				<span style="vertical-align: top;">inch</span>
				<!-- <vSelect
					v-model="formData.lengthUnit"
					class="inline-block margin-right-15 width-60 vertical-top"
				>
					<vOption v-for="(item,index) in getLenUnitList" :key="index" :value="index">{{item}}</vOption>
				</vSelect> -->
			</vFormItem>
			<vFormItem label-width="130" inline label="包裹重量" class="margin-bottom-5">
				<vInputNumber
					clearable
					v-model="formData.packedWeight "
					min="0.001"
					class="inline-block margin-right-15 width-100"
					precision="3"
				/>
				<span style="vertical-align: top;">lbs</span>
				<!-- <vSelect
					v-model="formData.weightUnit"
					class="inline-block margin-right-15 width-100 vertical-top"
				>
					<vOption v-for="(item,index) in getWeightUnitList" :key="index" :value="index">{{item}}</vOption>
				</vSelect> -->
				<vCheckbox
					v-if="datalist.length>1"
					v-model="formData.isSplit"
					class="vertical-top"
					:trueValue="1"
					:falseValue="0"
					:strict="false"
				>拆分包裹</vCheckbox>
				<span v-if="formData.isSplit==1" class="color-error">勾选拆分包裹，则系统将自动拆分成单个Seller SKU，单个数量去申请SFP面单。</span>
			</vFormItem>
		</template>
		<vTable
			style="margin:0 16px"
			:columns="columns"
			:data="datalist"
			size="small"
			ref="table"
			border
			stripe
		></vTable>
	</section>
</template>


<script>
import { mapGetters } from "vuex";
// import {} from "@/service/sfp/sfp";
export default {
	props: ["datainfo", "datalist", "query"],
	data() {
		return {
			formData: this.datainfo || {}
		};
	},
	created() {
		this.formData = this.exchangeRateData(this.formData)
	},
	components: {
		compPackagesize: () => import("../calculation/packagesize"),
	},
	computed: {
		// ...mapGetters("common", ["getLenUnitList", "getWeightUnitList"]),
		// getDatainfo() {
		// 	return { ...this.datainfo, lengthUnit: this.formData.lengthUnit, weightUnit: this.formData.weightUnit }
		// },
		columns() {
			return [
				{
					title: "ERP SKU",
					key: "erpSku"
				},
				{
					title: "Seller SKU",
					key: "sellerSku"
				},
				{
					title: "erpSku数量",
					key: "erpskuQuantity"
				},
				{
					title: "单包裹数量(Seller SKU数量)",
					key: "singlePackageQuantity"
				}
				
			];
		}
	},
	watch: {
		datainfo(val) {
			this.formData = this.exchangeRateData(val);
		}
	},
	methods: {
		exchangeRateData(data) {
			data = { ...data };
			// const lengthUnit = this.getLenUnitList[data.lengthUnit],
			// 	weightUnit = this.getWeightUnitList[data.weightUnit],
			const rate = {
				'inch': 2.54,
				'lbs': 453.59237,
				'cm': 1,
				'g': 1
			},
			exchange = function (val = 0, type) {
				return Number(val / (rate[type] || 1)).toFixed(3);
			};
			['packedLength', 'packedWidth', 'packedHeight'].forEach(key => {
				data[key] = exchange(data[key], 'inch');
			});
			['packedWeight'].forEach(key => {
				data[key] = exchange(data[key], 'lbs');
			});
			return data;
		},
		validate() {
			const keys = ['packedLength', 'packedWidth', 'packedHeight', 'lengthUnit', 'packedWeight', 'weightUnit'];
			return !keys.some(function (key) {
				return this[key] === '' || this[key] === undefined
			}, this.formData)
		},
	}
};
</script>